import { useOverviewStore } from "../overviewStore";
import type { SearchDTO } from "../types";

export const moveMapPosition = ({ params, animate }: { params: Partial<SearchDTO>; animate: boolean }) => {
    const overviewStore = useOverviewStore();
    const { max_lat, max_long, min_lat, min_long } = params;
    if (max_lat && min_lat && max_long && min_long) {
        overviewStore.map?.fitBounds([min_long, min_lat, max_long, max_lat], { animate }, { movedByUpdateMapFn: true });
    }
};
